import React from 'react';

export type Props = {
  className?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

export const VisaLogo = React.memo((props: Props) => {
  const {
    width = 38,
    height = 13,
    className,
    onClick,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox='0 0 38 13'
    >
      <g id='logo-/-payment-/-visa' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='visa' transform='translate(-1.000000, -1.000000)' fillRule='nonzero'>
          <path d='M17.1462118,13.0108285 L14.0793354,13.0108285 L15.9960938,1.23109895 L19.0632853,1.23109895 L17.1462118,13.0108285 Z M11.4992898,1.23109895 L8.57546915,9.33328665 L8.22948844,7.58857334 L8.22980354,7.58920355 L7.19784831,2.29172835 C7.19784831,2.29172835 7.07306838,1.23109895 5.74302777,1.23109895 L0.909381002,1.23109895 L0.852662852,1.43055778 C0.852662852,1.43055778 2.33080086,1.73809619 4.06070443,2.77698363 L6.72519706,13.0111436 L9.9206346,13.0111436 L14.799971,1.23109895 L11.4992898,1.23109895 Z M35.621834,13.0108285 L38.4378901,13.0108285 L35.9826244,1.23078385 L33.5172755,1.23078385 C32.3788162,1.23078385 32.1015275,2.10865477 32.1015275,2.10865477 L27.5275238,13.0108285 L30.7245369,13.0108285 L31.3638764,11.2610735 L35.262619,11.2610735 L35.621834,13.0108285 Z M32.2471041,8.84393506 L33.8585297,4.43567442 L34.7650748,8.84393506 L32.2471041,8.84393506 Z M27.7673155,4.06385543 L28.2049906,1.53422595 C28.2049906,1.53422595 26.8544684,1.0206116 25.4465979,1.0206116 C23.9246609,1.0206116 20.3104543,1.68578945 20.3104543,4.9202995 C20.3104543,7.96354333 24.5523417,8.00135543 24.5523417,9.59986196 C24.5523417,11.1983685 20.7474992,10.9119418 19.4918224,9.90393426 L19.0358715,12.5488906 C19.0358715,12.5488906 20.4052997,13.2140685 22.4975692,13.2140685 C24.590469,13.2140685 27.7477793,12.1304367 27.7477793,9.18109295 C27.7477793,6.11831286 23.4677647,5.83314661 23.4677647,4.50153049 C23.4680798,3.16959927 26.4549206,3.34069902 27.7673155,4.06385543 L27.7673155,4.06385543 Z' id='Shape' fill='#2566AF'></path>
          <path d='M8.22980354,7.58888844 L7.19784831,2.29141325 C7.19784831,2.29141325 7.07306838,1.23078385 5.74302777,1.23078385 L0.909381002,1.23078385 L0.852662852,1.43024268 C0.852662852,1.43024268 3.17590129,1.91171675 5.40429437,3.71566901 C7.5350062,5.43990077 8.22980354,7.58888844 8.22980354,7.58888844 Z' id='Path' fill='#E6A540'></path>
        </g>
      </g>
    </svg>
  );
});

VisaLogo.displayName = 'VisaLogo';
